import { FilterProvider, FormContext, PaginationProvider } from 'dash-ui';
import MarketingFiles from 'containers/properties/PropertyPreview/components/MarketingFilesSection/components/MarketingFiles/MarketingFiles';
import { useContext } from 'react';
import { ManageMediaKitFormFields } from 'containers/portfolio/ManageMediaKitModal/ManageMediaKitModal.constants';

const MarketingFilesWrapper = ({
  isAddedToMediaKit,
  compactMediaList,
}: {
  isAddedToMediaKit?: boolean;
  compactMediaList?: boolean;
}) => {
  const { formState } = useContext(FormContext);

  return (
    <FilterProvider>
      <PaginationProvider perPage={8}>
        <MarketingFiles
          propertyId={formState[ManageMediaKitFormFields.CurrentPropertyId]}
          isMediaKit
          showMediaKit
          portfolioId={formState[ManageMediaKitFormFields.CurrentPortfolioId]}
          isAddedToMediaKit={isAddedToMediaKit}
          compactMediaList={compactMediaList}
        />
      </PaginationProvider>
    </FilterProvider>
  );
};

export default MarketingFilesWrapper;
